import { HttpErrorResponse, HttpInterceptorFn} from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, EMPTY, throwError } from "rxjs";
import { Router } from "@angular/router";
import { ToastService } from "../../utils/toast.service";
import { AuthService } from "../../modules/authentication/services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toast = inject(ToastService);
  const router = inject(Router);

  const isPublicRequest = [
    '/send-reset-password',
    '/confirm-reset-password',
    '/change-password',
    '/get-token',
    '/validate-reset-token'
  ].some(path => req.url.includes(path));

  const isFirebaseRequest = req.url.startsWith('https://identitytoolkit.googleapis.com');

  if (isPublicRequest || isFirebaseRequest) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        toast.showToast(
          'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]',
          'Tu sesión ha expirado',
          'error'
        );
        authService.signOut().subscribe(() => router.navigateByUrl('/login'));
        return EMPTY;
      }
      return throwError(() => new Error(error.error?.message || 'Error desconocido'));
    })
  );
};